'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
// import createLogger from 'vuex/dist/logger'

import LayoutStore from '@/layouts/'
import LoginStore from '../modules/login/_store'

import UsersStore from '../modules/users/_store'
import CustomersStore from '../modules/customers/_store'
import TransactionsStore from '../modules/transactions/_store'
import BudgetsStore from '../modules/budgets/_store'
import CardsStore from '../modules/cards/_store'
import ConfigStore from '../modules/config/'
import GlobalStore from '../modules/global/_store'
import SnackBars from '@/components/SnackBars/_store'
import ResourcesStore from '../modules/resources'
import LogsStore from '../modules/logs/_store'
import CategoriesStore from '../modules/categories/_store'
import DashboardStore from '../modules/dashboard/_store'
import CompanyStore from '../modules/company/_store'
import AccountingStore from '../modules/accounting/_store'
import MerchantsStore from '../modules/merchants/_store'
import BenefitsStore from '../modules/benefits/_store'
import FiltersStore from '../modules/filters/_store'
import ExportStore from '../modules/export/_store'

Vue.use(Vuex)

export default new Vuex.Store({
  // plugins: [createLogger()],
  modules: {
    LayoutStore,
    LoginStore,
    UsersStore,
    CustomersStore,
    TransactionsStore,
    CardsStore,
    GlobalStore,
    BudgetsStore,
    ConfigStore,
    ResourcesStore,
    LogsStore,
    CategoriesStore,
    DashboardStore,
    CompanyStore,
    AccountingStore,
    MerchantsStore,
    BenefitsStore,
    FiltersStore,
    ExportStore,
    SnackBars
  }

})
